import React from "react";

export default function Termsofservice() {
  return (
    <>
      <section id="tos" className="tos">
        <div className="container">
          <div className="section-title mt-3">
            <h2>Terms of service</h2>
          </div>
        </div>

        <div className="container">
          <h3>Acceptance of Terms</h3>
          <ul>
            <li>
              By downloading or using the WeLearn app, you agree to comply with
              and be bound by these Terms and Conditions.
            </li>
            <li>
              If you do not agree to these terms, you must not use the app.
            </li>
          </ul>
          <h3>User Account</h3>
          <ul>
            <li>Users must create an account to access certain features.</li>
            <li>
              You are responsible for maintaining the confidentiality of your
              login information.
            </li>
            <li>
              You agree to provide accurate and current information during
              registration.
            </li>
          </ul>
          <h3>
            You agree to provide accurate and current information during
            registration.
          </h3>
          <ul>
            <li>The app is for educational purposes only.</li>
            <li>
              Unauthorized use of the app, including but not limited to hacking,
              is prohibited.
            </li>
            <li>
              You agree not to use the app for any unlawful or prohibited
              activities.
            </li>
          </ul>
          <h3>Intellectual Property</h3>
          <ul>
            <li>
              All content provided in the app, including but not limited to
              text, graphics, logos, and software, is the property of WeLearn.
            </li>
            <li>
              You may not reproduce, distribute, or create derivative works from
              any content without express written permission from WeLearn.
            </li>
          </ul>
          <h3>Terms & Conditions</h3>
          {/* <p>These Terms & Conditions (“Terms”) of (a) use of our website  (“Website”), our applications (“Application”) or any products or services in connection with the Application/,  Website/products (“Services”)  or (b) any modes of registrations or usage of products, including through SD cards, tablets or other storage/transmitting device  are between Think & Learn Private Limited (“Company/We/Us/Our”) and its users (“User/You/Your”).</p> */}
          <p>
            These Terms constitute an electronic record in accordance with the
            provisions of the Information Technology Act, 2000 and the
            Information Technology (Intermediaries guidelines) Rules, 2011
            thereunder, as amended from time to time.
          </p>
          <p>
            Please read the Terms and the privacy policy of the Company
            (“Privacy Policy”) with respect to registration with us, the use of
            the Application, Website, Services and products carefully before
            using the Application, Website, Services or products. In the event
            of any discrepancy between the Terms and any other policies with
            respect to the Application or Website or Services or products, the
            provisions of the Terms shall prevail.
          </p>
          <p>
            Your use/access/browsing of the Application or Website or the
            Services or products or registration (with or without payment/with
            or without subscription) through any means shall signify Your
            acceptance of the Terms and Your agreement to be legally bound by
            the same.
          </p>
          <p>
            If you do not agree with the Terms or the Privacy Policy, please do
            not use the Application or Website or avail the Services or
            products. Any access to our Services/Application/products through
            registrations/subscription is non transferable.
          </p>
        </div>
      </section>
    </>
  );
}
